export default "__VITE_ASSET__BCoO2oQA__";